export const calendar = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        start_date:'Start Date',
        end_date:'End Date',
        apply:'Apply',
        cancel:'Cancel',
        monday:'Mo',
        tuesday:'Tu',
        wednesday:'We',
        thursday:'Th',
        friday:'Fr',
        saturday:'Sa',
        sunday:'Su',
        january:'January',
        february:'February',
        march:'March',
        april:'April',
        may:'May',
        june:'June',
        july:'July',
        august:'August',
        september:'September',
        october:'October',
        november:'November',
        december:'December'
    },

    ar: {
        start_date:'البيانات الرئيسية',
        end_date:'إدارة العناوين',
        apply:'إدارة العناوين',
        cancel:'إدارة العناوين',
        monday:'مون',
        tuesday:'بر',
        wednesday:'بنت',
        thursday:'جمرات',
        friday:'معة',
        saturday:'گل',
        sunday:'شمس',     
        january:'يناير',
        february:'فبراير',
        march:'مارس',
        april:'إبريل',
        may:'مايو',
        june:'يونية',
        july:'يولية',
        august:'أغسطس',
        september:'سبتمبر',
        october:'أكتوبر',
        november:'نوفمبر',
        december:'ديسمبر'
    },

}
   